import { useState } from "react";
import {
  ResponseGetPlanInfoListResponse,
  RequestGetPlanInfoListRequest,
  PlansGetPlansInfoListPostRequest,
  PlansApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetPlanInfoList = () => {
  const [planInfoList, setPlanInfoList] = useState<
    ResponseGetPlanInfoListResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchPlanInfoList = async (
    requestParams: RequestGetPlanInfoListRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();
      const request: PlansGetPlansInfoListPostRequest = {
        req: requestParams,
      };

      const api = new PlansApi(config);
      const response = await api.plansGetPlansInfoListPost(request);
      setPlanInfoList(response);
      return response;
    } catch (err) {
      setError("プラン情報の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { planInfoList, fetchPlanInfoList, error, isLoading };
};
